import { all, call, put, select, take, takeEvery } from 'redux-saga/effects';
import { apiCall } from 'utils/swaggerClient';
import {
  throwErrorTest,
  handleError,
  getErrorMessage,
} from 'utils/errorHandling';
import { selectBillingAccountId } from 'containers/PrimoAccount/selectors';
import { getSurcharge } from './selectors';
import actions, { types } from './actions';

function* fetchSurcharge({ payload }) {
  try {
    throwErrorTest('fetchSurcharge');
    const billingAccountId = yield select(selectBillingAccountId());
    const { id, amount } = payload;

    const response = yield call(apiCall, {
      operationId: 'BillingAccounts.retrievePaymentSurcharge',
      parameters: { billingAccountId },
      options: {
        requestBody: {
          amount,
          paymentMethodId: id,
        },
      },
    });

    const results = {
      [`${amount}-${id}`]: {
        ...response,
        subTotal: amount,
        grandTotal: amount + response.surchargeAmount,
      },
    };

    yield put(actions.receive(results));
  } catch (error) {
    yield handleError('fetchSurcharge', types.FAIL, getErrorMessage(error));
  }
}

export function* getOrFetchSurcharge(action) {
  const { id, amount } = action.payload;
  const results = yield select(getSurcharge(id, amount));

  if (results) {
    yield put(actions.receive({}));
    return results;
  }

  yield call(fetchSurcharge, action);
  yield take(types.RECEIVE);
  return yield select(getSurcharge(id, amount));
}

export default function* surchargesSaga() {
  yield all([takeEvery(types.REQUEST, getOrFetchSurcharge)]);
}
